import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { fetchData } from "../../redux/slices/mainDataSlice";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeading,
  faEarthAsia,
  faLandmark,
  faSchool,
  faGears,
  faFlag,
  faBookOpen,
  faCompassDrafting,
  faUserTie,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
import Can from "../../permissions/Can";

export default function Tarwees() {
  const [fields, setFields] = useState(["", "", "", "", "", "", "", ""]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.main.token);
  const tarweesData = useSelector(
    (state) => state.main.data?.tarweesData || []
  );
  const initializedRef = useRef(false);

  const placeholders = [
    "الدولة",
    "الوزارة",
    "المديرية",
    "الإدارة العامة للشؤون الإدارية",
    "State Of Palestine",
    "Ministry of Education & Higher Education",
    "Directorate of Education",
    "D.G Of Administrative Affairs",
  ];

  const icons = [
    faEarthAsia,
    faLandmark,
    faSchool,
    faGears,
    faFlag,
    faBookOpen,
    faCompassDrafting,
    faUserTie,
  ];

  const colors = [
    "#2E86C1",
    "#AF7AC5",
    "#F39C12",
    "#16A085",
    "#D35400",
    "#2980B9",
    "#C0392B",
    "#7D3C98",
  ];

  useEffect(() => {
    if (!tarweesData || tarweesData.length === 0) {
      dispatch(fetchData());
    }
  }, [dispatch, tarweesData]);

  useEffect(() => {
    if (!initializedRef.current && tarweesData.length > 0) {
      const data = tarweesData[0];
      setFields([
        data?.u1 || "",
        data?.u2 || "",
        data?.u3 || "",
        data?.u4 || "",
        data?.u5 || "",
        data?.u6 || "",
        data?.u7 || "",
        data?.u8 || "",
      ]);
      initializedRef.current = true;
    }
  }, [tarweesData]);

  const handleInputChange = (index, value) => {
    const updatedFields = [...fields];
    updatedFields[index] = value;
    setFields(updatedFields);
  };

  const handleSave = async () => {
    const payload = {
      u1: fields[0],
      u2: fields[1],
      u3: fields[2],
      u4: fields[3],
      u5: fields[4],
      u6: fields[5],
      u7: fields[6],
      u8: fields[7],
    };
    const loadingToast = toast.loading("جارٍ حفظ التعديلات...");
    try {
      await axios.put(
        `https://api.alfares.cloud/api/alfares/updateTarwees/${token}`,
        payload
      );
      toast.success("تم حفظ ترويسة الوزارة بنجاح", { id: loadingToast });
      initializedRef.current = false;
      dispatch(fetchData());
    } catch (error) {
      toast.error("فشل حفظ البيانات", { id: loadingToast });
    }
  };

  return (
    <div className="tarwees-wrapper anim-fade-in" style={{ padding: "5px" }}>
      <div className="premium-edit-container">
        {/* Premium Header */}
        <div className="premium-header-modern">
          <div className="header-left">
            <div className="header-icon-box">
              <FontAwesomeIcon icon={faHeading} />
            </div>
            <div className="header-text-box">
              <h2>ترويسة الوزارة الرسمية</h2>
              <div className="breadcrumb-info">
                <span>نظام الفارس</span>
                <span className="separator">/</span>
                <span className="current-page">
                  اعداد ترويسة الكتب الرسمية من دولة فلسطين
                </span>
              </div>
            </div>
          </div>
          <div className="header-right">
            <img
              src="/images/nsr-logo.png"
              alt="Palestinian Authority Eagle"
              className="header-logo-img"
            />
            <div className="logo-text">{fields[0] || "دولة فلسطين"}</div>
            <div className="logo-text sub-text">
              {fields[1] || "وزارة التربية والتعليم العالي"}
            </div>
          </div>
        </div>

        <div className="premium-form">
          <div className="section-grid">
            {[0, 4, 1, 5, 2, 6, 3, 7].map((idx) => (
              <div className="input-field" key={idx}>
                <label>{placeholders[idx]}</label>
                <div className="input-wrapper">
                  <FontAwesomeIcon
                    icon={icons[idx]}
                    className="field-icon"
                    style={{ color: colors[idx], opacity: 0.8 }}
                  />
                  <input
                    type="text"
                    value={fields[idx]}
                    onChange={(e) => handleInputChange(idx, e.target.value)}
                    placeholder={`أدخل ${placeholders[idx]}...`}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="form-actions">
            <Can module="tarwees" action="edit">
              <button onClick={handleSave} className="premium-submit-btn">
                <div className="btn-content">
                  <FontAwesomeIcon icon={faFloppyDisk} />
                  <span>حفظ التعديلات</span>
                </div>
              </button>
            </Can>
          </div>
        </div>
      </div>

      <style>{`
        .tarwees-wrapper { 
          padding: 5px; 
          color: var(--text); 
          font-family: 'Cairo', sans-serif; 
        }
        
        .premium-edit-container {
          margin: 0;
          background: transparent;
          border: none;
          border-radius: 0;
          overflow: visible;
          box-shadow: none;
          width: 100%;
        }

        .premium-header-modern {
          display: flex; justify-content: space-between; align-items: center;
          padding: 15px 40px; 
          background: rgba(255, 255, 255, 0.7);
          backdrop-filter: blur(10px);
          border: 1px solid var(--border);
          border-radius: 24px 24px 0 0;
          gap: 20px;
        }
        
        .header-right {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
        }

        .logo-text {
          font-size: 14px;
          font-weight: 700;
          color: var(--text);
          text-align: center;
        }

        .logo-text.sub-text {
          font-size: 12px;
          font-weight: 600;
          margin-top: -2px;
          opacity: 0.9;
        }

        .header-logo-img {
          height: 110px;
          width: auto;
          filter: drop-shadow(0 4px 6px rgba(0,0,0,0.2));
          transition: transform 0.3s ease;
        }
        
        .header-logo-img:hover {
          transform: scale(1.05);
        }
        
        .premium-form {
          background: rgba(255, 255, 255, 0.5);
          backdrop-filter: blur(10px);
          border: 1px solid var(--border);
          border-top: none;
          border-radius: 0 0 24px 24px;
          padding: 15px 40px !important;
        }

        .header-left { display: flex; align-items: center; gap: 15px; }

        .section-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 25px; }

        .header-icon-box {
          width: 48px; height: 48px; background: var(--accent);
          border-radius: 14px; display: flex; align-items: center; justify-content: center;
          font-size: 20px; color: white;
          box-shadow: 0 8px 16px -4px color-mix(in srgb, var(--accent) 40%, transparent);
        }

        .header-text-box h2 { margin: 0; font-size: 20px; font-weight: 800; }
        .breadcrumb-info { display: flex; align-items: center; gap: 4px; color: var(--muted); font-size: 12px; margin-top: 2px; }
        .breadcrumb-info span:first-child { color: #d97706; font-weight: 500; }
        .current-page { color: var(--accent); font-weight: 600; }
        .separator { margin: 0 6px; }

        .input-field label { display: block; font-size: 11px; font-weight: 800; margin-bottom: 2px; color: var(--muted); margin-right: 5px; }
        .input-wrapper { position: relative; display: flex; align-items: center; }
        .field-icon { position: absolute; right: 16px; font-size: 14px; transition: 0.3s; pointer-events: none; }
        .input-wrapper input {
          width: 100%; height: 42px; background: rgba(255, 255, 255, 0.7); border: 1.5px solid var(--border);
          border-radius: 10px; padding: 0 45px 0 15px; color: var(--text); font-family: inherit; font-size: 14px; font-weight: 400; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .input-wrapper input:focus { border-color: var(--accent); outline: none; background: rgba(255, 255, 255, 0.8); box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 15%, transparent); }
        .input-wrapper input:focus + .field-icon { color: var(--accent); transform: scale(1.1); }

        .premium-submit-btn {
          background: var(--accent);
          border: none; color: white; font-size: 15px; font-weight: 700; cursor: pointer;
          padding: 0 30px; border-radius: 12px;
          position: relative; overflow: hidden; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 15px rgba(14, 165, 233, 0.4); font-family: 'Cairo', sans-serif;
          height: 48px;
          min-width: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .form-actions {
          display: flex;
          justify-content: flex-end;
          margin-top: 25px;
        }
        .btn-content { position: relative; z-index: 2; display: flex; align-items: center; justify-content: center; gap: 12px; }
        .premium-submit-btn:hover { transform: translateY(-2px); filter: brightness(1.1); box-shadow: 0 15px 30px -8px rgba(14, 165, 233, 0.6); }
        .premium-submit-btn:active { transform: translateY(0); }

        @media (max-width: 900px) {
          .premium-header-modern { 
            padding: 15px 20px; 
            flex-direction: column;
            text-align: center;
            gap: 15px;
          }
          .header-left {
            flex-direction: column;
            gap: 10px;
          }
          .header-text-box h2 {
            font-size: 18px;
          }
          .breadcrumb-info {
            justify-content: center;
            flex-wrap: wrap;
          }
          .header-logo-img {
            height: 80px;
          }
          .header-icon-box {
            display: none;
          }
          .logo-text {
            font-size: 12px;
          }
          .logo-text.sub-text {
            font-size: 10px;
          }
          .premium-form { padding: 20px !important; }
          .section-grid { grid-template-columns: 1fr !important; gap: 12px; }
          .input-wrapper input { height: 46px; font-size: 13px; }
          .premium-submit-btn {
            width: 100%;
            min-width: unset;
          }
        }
      `}</style>
    </div>
  );
}
